import { render, staticRenderFns } from "./DepositBlock.vue?vue&type=template&id=dbcc5afa&scoped=true&"
import script from "./DepositBlock.vue?vue&type=script&lang=ts&"
export * from "./DepositBlock.vue?vue&type=script&lang=ts&"
import style0 from "./DepositBlock.vue?vue&type=style&index=0&id=dbcc5afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcc5afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VTooltip})
